import React from "react";
import { useNavigate } from "react-router-dom";
import { X, Infinity, Brain, Radar, BookOpen, History, Gift } from "lucide-react";

// Sprint M5.36 (29.07.2026) — Issue 5: Feature-Liste spec-konform auf das
// gekuerzt, was in Sprint M5.35 tatsaechlich live ist. Overpromise-Begriffe
// (Aktivitaets-Analyse, Wochen-Trends, Risiko-Vorausschau, 8 Hot Tips,
// Flexpfad-Coach, Wochen-Mail) entfernt. Wording v8: „Flexpfad" als Modul,
// „Flexpfade" nur als konkrete Instanz.
const FEATURES = [
  { icon: Infinity, label: "Unbegrenzte Flexpfade pro Tag (Soft-Cap 100)" },
  { icon: Brain, label: "Primärfokustyp-Analyse (20 Fragen)" },
  { icon: Radar, label: "Mustererkennung ab 7 Flexpfaden" },
  { icon: BookOpen, label: "Flexpfad-Bibliothek — Vollzugriff" },
  { icon: History, label: "Unbegrenzter Verlauf deiner Flexpfade" },
  { icon: Gift, label: "Im Launch-Angebot: PowerPaket kostenfrei dazu" },
];

export default function CockpitPreviewModal({ open, onClose }) {
  const navigate = useNavigate();
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center px-4"
      onClick={onClose}
      data-testid="cockpit-preview-modal"
    >
      <div
        className="bg-white rounded-2xl max-w-lg w-full p-7 max-h-[90vh] overflow-y-auto relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Schließen"
          data-testid="cockpit-preview-close"
          className="absolute top-4 right-4 text-slate-400 hover:text-slate-700"
        >
          <X className="w-5 h-5" />
        </button>
        <h3 className="text-xl font-extrabold tracking-tight text-[var(--fts-text-primary)]">
          Dein PocketCoach mit Pro Solo
        </h3>
        <p className="mt-1 text-sm text-slate-600">Was du freischaltest:</p>
        <ul className="mt-4 space-y-2.5">
          {FEATURES.map(({ icon: Icon, label }, i) => (
            <li key={i} className="flex items-start gap-2.5 text-sm">
              <Icon className="w-4 h-4 text-[var(--fts-primary-bright)] flex-shrink-0 mt-0.5" />
              <span className="text-slate-700">{label}</span>
            </li>
          ))}
        </ul>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-2">
          <button
            type="button"
            onClick={() => navigate("/dashboard/abo")}
            data-testid="cockpit-preview-monthly-cta"
            className="rounded-xl bg-[var(--fts-primary-bright)] hover:bg-[var(--fts-primary-deep)] text-white font-bold px-4 py-3 text-sm"
          >
            Pro Solo · 39 €/Monat
          </button>
          <button
            type="button"
            onClick={() => navigate("/dashboard/abo")}
            data-testid="cockpit-preview-yearly-cta"
            className="rounded-xl bg-[var(--fts-primary-deep)] hover:opacity-90 text-white font-bold px-4 py-3 text-sm"
          >
            Jahresplan ansehen
          </button>
        </div>
        <button
          type="button"
          onClick={onClose}
          data-testid="cockpit-preview-later"
          className="mt-3 w-full text-center text-sm text-slate-500 hover:text-slate-700"
        >
          Später
        </button>
      </div>
    </div>
  );
}
